import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
import strings from "../../config/localization";
import CustomMapComponent from "./CustomMapComponent";

export default function ShowLocationsDialog(props) {
  console.log("ShowLocationsDialog, props:", props);

  return (
    <Dialog
      open={props.state}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullScreen
    >
      <DialogTitle id="alert-dialog-title">{strings.locations}</DialogTitle>
      <DialogContent>
        <CustomMapComponent
          data={props.data}
          onClose={props.onClose}
          onSelect={props.onSelect}
          defaultZoom={props.defaultZoom}
          defaultCenter={props.defaultCenter}
        />
      </DialogContent>
    </Dialog>
  );
}
